import { isDeepEqual } from '@interxfi/utilities/equality/deep';

/**
 * Compares two objects of the same shape key-by-key and returns the section ids
 * (from the provided map) for keys whose values differ.
 *
 */
export function getChangedKeyIds<T extends object>(baseline: T, next: T, idByKey: { readonly [K in keyof T]: string }): string[] {
  return (Object.keys(idByKey) as (keyof T)[]).filter((key) => !isDeepEqual(baseline[key], next[key])).map((key) => idByKey[key]);
}
